<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled': props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">* {{responseError}}</span>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="name"
                  label="City Name"
                  v-model="city.name"
                  type="text"
                  :rules="rules.nameRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Description"
                  v-model="city.description"
                  type="text"
                  :rules="rules.descriptionRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="city.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="city.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="city.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="city.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="city.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="city.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-layout row wrap>
                  <v-btn color="success" @click="addTownship()">
                    Add Township
                    <v-icon right>add</v-icon>
                  </v-btn>
                </v-layout>
                <v-layout row wrap class="light--text">
                  <v-flex sm3>Name</v-flex>
                  <v-flex sm3>Description</v-flex>
                  <v-flex xs1>Action</v-flex>
                </v-layout>
                <v-layout row wrap v-for="(township, index) in city.townships" :key="index">
                  <v-flex sm3>
                    <v-text-field
                      name="name"
                      label="Township Name"
                      v-model="township.name"
                      type="text"
                      :rules="rules.nameRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm3>
                    <v-text-field
                      name="description"
                      label="Description"
                      v-model="township.description"
                      type="text"
                      :rules="rules.descriptionRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs1 v-if="index == 0 || township.id">
                    <v-btn icon @click="removeTownship(index)" disabled>
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex xs1 v-else>
                    <v-btn icon @click="removeTownship(index)">
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn color="primary" :loading="saveLoading" :disabled="!valid" type="submit">
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import { cityService } from "../../services/city-service";
import { City } from "../../models/model";
import { Township } from "../../models/model";
import { commonService } from "../../services/common-service";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { CityFormRules } from "../../helpers/validation-rules";
export default {
  name: "CityDetail",
  components: { VSwitch },
  data: () => ({
    valid: true,
    breadcrumbs: [
      {
        text: "City",
        disabled: false,
        to: "cities"
      },
      {
        text: "City Detail",
        disabled: true
      }
    ],
    createdDate: "",
    updatedDate: "",
    city: new City(),
    oldCity: new City(),
    township: new Township(),
    saveLoading: false,
    responseError: "",
    rules: new CityFormRules()
  }),
  created() {
    const id = this.$route.params.id;
    if (id == "new") {
      // new city
      this.initTownship();
    } else {
      this.getCityDetail(id);
    }
  },
  methods: {
    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        cityService
          .saveCity(this.city)
          .then(res => {
            console.log(res);
            this.goBack();
          })
          .catch(err => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },
    getCityDetail(id) {
      cityService
        .getCityDetail(id)
        .then(res => {
          this.city = res.data;
          this.createdDate = commonService.formatDate(
            new Date(this.city.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.city.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          // deep copy
          this.oldCity = JSON.parse(JSON.stringify(res.data));

          this.statusFlag = this.city.status == "ACTIVE" ? true : false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    clear() {
      this.$refs.form.resetValidation();
      if (!this.city.id) {
        this.city = new City();
      } else {
        this.city = Object.assign({}, this.oldCity);
      }
    },
    goBack() {
      this.$router.push("/cities");
    },

    initTownship() {
        let t = JSON.parse(JSON.stringify(this.township));
        this.city.townships.push(t);
    },

    addTownship() {
      // deep copy
      let t = JSON.parse(JSON.stringify(this.township));
      this.city.townships.push(t);
    },

    removeTownship(index) {
      this.$delete(this.city.townships, index);
    }
  }
};
</script>

